import script from "./GradecamScanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./GradecamScanner.vue?vue&type=script&setup=true&lang=ts"

import "./GradecamScanner.vue?vue&type=style&index=0&id=72289066&scoepd=true&lang=css"

const __exports__ = script;

export default __exports__